// Знак «?» з підказкою у рядку таблиці (єдиний для всіх форм нарахувань — ЗП/аванс/
// компенсація/лікарняний/відпустка). Дизайн = PayrollEditor (сірий кружок «?» + бульбашка).
export default function InfoQ({ title }: { title: string }) {
  return (
    <span className="pe-tip" style={{ marginLeft: 3, verticalAlign: 'middle', flex: 'none' }}>
      <span
        style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: 13, height: 13, borderRadius: '50%',
          background: 'var(--border)', color: 'var(--text-secondary)', fontSize: '0.58rem',
          fontWeight: 700, cursor: 'help',
        }}
      >?</span>
      <span className="pe-tip-bubble">{title}</span>
    </span>
  );
}
